// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import EnvironmentDetails from './components/EnvironmentDetails';
import EnvironmentScenario from './components/EnvironmentScenario';
import PETargetObjectArray from './components/PETargetObjectArray';
import PECoordinateTab from './components/PECoordinateTab';

const PEEnvironmentBase = (props) => {
  const { control, formState, setValue, getValues, watch } = props.methods;
  const { errors } = formState;
  const { inputDir, possiblePages } = props;

  const lessonLabel = props.section?.lesson?.label || '';

  return (
    <div>
      <EnvironmentDetails {...{ control, errors, inputDir }} />

      <Divider className="my-16" />

      <EnvironmentScenario {...{ control, errors, inputDir }} />

      <Divider className="my-16" />

      <NumberedHeading
        number="6"
        title="Tasking Threads"
        instructions="Using the controls below, add the tasking and branching for each interactable object in the environment."
      />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => (
          <PETargetObjectArray
            {...{ control, errors, inputDir, setValue }}
            possiblePages={possiblePages}
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="7"
        title="View Controls"
        instructions="Using the controls below, add the views and hotspots. System expects 6 views in this order: immersive center, immersive left, immersive right, isometric center, isometric left and isometric right."
      />
      <PECoordinateTab
        {...{ control, errors, setValue, getValues, lessonLabel }}
      />
    </div>
  );
};

export default PEEnvironmentBase;
